<template>

    <div>
        <canvas id="ticketsProportion"></canvas>
    </div>


</template>

<script>
    import Chart from 'chart.js'
    import ChartDataLabels from 'chartjs-plugin-datalabels';

    Chart.plugins.unregister(ChartDataLabels);


    export default {
        name: "ticketsProportions",
        props: {
            tickets: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                dataset: [],
                labels: [],
                colors: [],
                chart: undefined

            }
        },
        watch: {
            tickets: function (newVal) {
                this.buildDataset(newVal.map(a => a));
                this.buildColors(this.dataset);
                this.drawChart()
            }
        },
        methods: {
            buildColors(dataset) {
                let max = Math.max(...dataset);
                this.colors = []
                dataset.forEach(values => {
                    this.colors.push('#006AD8' + Math.round((values / max * 255)).toString(16))
                })

            },
            buildDataset(tickets) {
                tickets.sort((nodeA, nodeB) => {
                    return nodeB.count - nodeA.count
                })
                this.dataset = tickets.map(val => {
                    return val.count
                })


                this.labels = tickets.map(val => {
                    return val.type
                })
            },
            drawChart() {
                if (this.chart) {
                    this.chart.destroy();
                }
                let canvas = document.getElementById("ticketsProportion")
                let chartOptions = {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    scales: {

                        yAxes: [{
                            gridLines: {
                                display: false

                            },
                        }],
                        xAxes: [{
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                beginAtZero: true,
                                display: false
                            }

                        }]
                    }
                };
                this.chart = new Chart(canvas, {
                    type: 'horizontalBar',
                    plugins: [ChartDataLabels],
                    data: {
                        datasets: [{
                            datalabels: {
                                color: '#EBF2FF',
                                anchor: 'end',
                                align: 'start'
                            },
                            backgroundColor: this.colors,
                            data: this.dataset
                        }],
                        labels: this.labels
                    },
                    options: chartOptions
                });
            }
        }
    }
</script>

<style scoped>

</style>
